import script from "./MatterSettlement.vue?vue&type=script&setup=true&lang=ts"
export * from "./MatterSettlement.vue?vue&type=script&setup=true&lang=ts"

import "./MatterSettlement.vue?vue&type=style&index=0&id=31e5ff92&lang=css"

const __exports__ = script;

export default __exports__